import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Input from '../Elements/Input/Input';
import Button from '../Elements/Button/Button';
import { changeAddressInput, forgot } from '../../actions/checkout';
import { translate } from '../../utils/locale';
import { fieldValidation } from '../../utils/string';
import s from './Account.scss';

const Forgot = ({ setup, checkout, toggleView, ...props }) => {
	const [errors, updateErrors] = useState({});
	const [sent, updateSent] = useState(false);

	const onAddressInputChange = (id, value) => {
		props.changeAddressInput('address', id, value);
		updateErrors((prevState) => {
			const { [id]: removed, ...nextState } = prevState;
			return nextState;
		});
	};

	const onAddressInputBlur = (id, value) => {
		onAddressInputChange(id, value);

		if (fieldValidation(value, id)) {
			updateErrors((prevState) => ({
				...prevState,
				[id]: translate(setup, `error${fieldValidation(value, id)}`),
			}));
		}
	};

	const onForgot = (e) => {
		e.preventDefault();

		// Ensure that we are using data from the fields as it may be autofilled.
		const $inputs = e.currentTarget.querySelectorAll('input');
		$inputs.forEach(($input) => {
			const id = $input.getAttribute('id');
			const value = $input.value;
			onAddressInputBlur(id, value);
		});

		if (Object.keys(errors).length > 0) return;

		props.forgot();

		updateSent(true);
		setTimeout(() => {
			updateSent(false);
		}, 2000);
	};


	return (
		<div className={s.unauthenticated}>
			<form className={s.unauthenticated_inner} onSubmit={onForgot}>
				<div className={s.unauthenticated_inner_fields}>
					<Input id="email" type="email" value={checkout.payment.address.email} isError={errors.email || false} inputChange={onAddressInputChange} label={translate(setup, 'labelEmail')} inputBlur={onAddressInputBlur} />
				</div>

				<Button variantClasses={['button__inverse']} textColor="#FFF5CA" type="submit" disabled={sent}>{ sent ? translate(setup, 'accountForgotSubmitSent') : translate(setup, 'accountForgotSubmit') }</Button>
				<div className={s.unauthenticated_inner_return}>
					<Button variantClasses={['button__invisible']} type="a" location="#login" clickEventHandler={toggleView}><span>{ translate(setup, 'accountBack') }</span></Button>
					<span className={s.unauthenticated_inner_return_or}>{ translate(setup, 'accountOr') }</span>
					<Button variantClasses={['button__invisible']} type="a" location="#register" clickEventHandler={toggleView}><span>{ translate(setup, 'accountRegister') }</span></Button>
				</div>
			</form>
		</div>
	);
};

const mapState = (props) => ({ ...props });

export default hot(module)(connect(mapState, { changeAddressInput, forgot })(Forgot));
